<template>
  <el-dialog title="处理结果" :visible.sync="handleVisible" width="530px" class="handleContent">
    <div class="p-20" style="padding-bottom: 10px;">
      <el-form ref="form">
        <el-form-item>
          <div class="flex">
            <el-input class="flex-1 font-12-30313a" type="textarea" placeholder="请输入处理结果" v-model="handleContent" resize="none"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <el-upload
        class="text-left"
        multiple
        name="file"
        :httpRequest="httpRequestImg"
        :action="upload"
        :show-file-list="false"
        :before-upload="beforeImgUpload">
        <div class="addBtn cursor mb-10 button">
          <img src="/static/images/customer/chubeikehu.png" alt="">
          <div>上传图片</div>
        </div>
      </el-upload>
      <div class="flex flex-wrap ">
        <div class="picItem mr-10 mb-10 relative" v-for="(item, index) in handlePic" :key="index">
          <viewer :images="handlePic">
            <img :src="Utils.IMG_PREV + item.path" alt="" fit="cover" style="width: 100%; height: 100%;">
          </viewer>
          <img src="/static/images/removeImg.png" class="absolute removeIcon" alt="" @click="removePic(index)">
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="btn-30-bd-85-s mr-10" @click="onCloseHandle">取消</div>
      <div class="btn-30-bg-46b8b0-s" @click="submitHandle">确定</div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'ToHandle',
  components: {},
  props: ['handleId', 'type'],
  data () {
    return {
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`,
      handleVisible: false,
      handleContent: null,
      handlePic: []
    }
  },
  created () {},
  mounted () {
  },
  methods: {
    beforeImgUpload () {},
    httpRequestImg (e) {
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 4)
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.handlePic.push({path: onloadRes.data.data.path})
        }
      }).catch(() => {
        this.$message.error('上传失败3！')
      })
    },
    removePic (index) {
      this.handlePic.splice(index, 1)
    },
    submitHandle () {
      if (this.handleContent === null || this.handleContent === '') {
        this.$message({
          message: '请输入处理结果',
          type: 'warning'
        })
      } else {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerHandleResult/save`, {
          handleId: this.handleId,
          content: this.handleContent,
          photoParamList: this.handlePic,
          type: this.type
        }).then(res => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            this.onCloseHandle()
            this.$parent.$parent.getHandleList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    onCloseHandle () {
      this.handleVisible = false
      this.handleContent = ''
      this.handlePic = []
    }
  }
}
</script>

<style lang="scss" scoped>
  .handleContent /deep/ .el-textarea__inner{
    padding-left: 10px;
    padding-right: 10px;
    height: 120px;
  }
  .addBtn{
    background: #fff;
    width: 85px;
    height: 24px;
    color: #30313a;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-radius: 4px;
  }
  .button{
    border: 1px solid #e2e2e2;
  }
  .picItem{
    width: 70px;
    height: 70px;
  }
  .removeIcon{
    top:5px;
    right: 5px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/components/ToHandle.vue